import React, { useEffect, useState } from 'react';
import { deacService } from '../../../services/central-api/deac';
import Toast from 'react-native-toast-message';
import { translate } from '../../../services/translate';
import { FlatList, View } from 'react-native';
import { MyCheckbox } from '../../../components/MyCheckbox';
import { useStyles } from 'react-native-unistyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { WindowInformation } from '../../../services/window-information';

interface VacancyLevelsInputs {
    actingBodyId: number;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    disabled?: boolean;
}

export default function VacancyLevelsInputs({ actingBodyId, setValue, value, disabled }: VacancyLevelsInputs) {
    const { theme } = useStyles();
    const windowInfo = WindowInformation();

    const [vacancyLevels, setVacancyLevels] = useState<SimplifiedVacancyLevel[]>([]);
    async function getVacancyLevels() {
        try {
            const response = await deacService.getVacancyLevelsSimplified(actingBodyId);
            setVacancyLevels(response);
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    useEffect(() => {
        if (actingBodyId > 0) {
            getVacancyLevels();
        }
    }, [actingBodyId]);

    const numColumns = windowInfo.isMobile ? 2 : 4;
    const numberOfRows = Math.ceil(vacancyLevels.length / numColumns);

    function renderVacancyLevelsItem(item: SimplifiedVacancyLevel, index: number) {
        const colIndex = index - ((numberOfRows - 1) * numColumns);
        const isLastElement = index === vacancyLevels.length - 1;
        return <MyCheckbox
            key={item.id}
            label={item.name}
            style={isLastElement ? { flex: numColumns - colIndex } : { flex: 1 }}
            checked={value.includes(item.id)}
            disabled={disabled}
            setChecked={(val => {
                if (val) {
                    setValue([...value, item.id]);
                } else {
                    setValue(value.filter(v => v != item.id));
                }
            })}
            customIcon={<FontAwesomeIcon icon={faCheck} fontSize={10} color={theme.colors.white['500']} />}
            checkBoxStyle={{
                backgroundColor: value.includes(item.id)
                    ? disabled ? theme.colors.primary['200'] : theme.colors.primary['500']
                    : disabled ? theme.colors.neutral['200'] : 'transparent',
                borderWidth: 1,
                borderColor: theme.colors.neutral['300']
            }}
        />;
    }

    return (
        <View style={{ flexDirection: 'row', gap: 45, flexWrap: 'wrap' }}>
            <FlatList
                data={vacancyLevels}
                renderItem={(item) => renderVacancyLevelsItem(item.item, item.index)}
                keyExtractor={(item, index) => `${item}-${index}`}
                numColumns={numColumns}
                scrollEnabled={true}
                style={{ maxHeight: 175 }}
                contentContainerStyle={{ justifyContent: 'space-around', gap: 10 }}
                columnWrapperStyle={numColumns > 1 ? { justifyContent: 'space-around' } : undefined}
            />
        </View>
    );
}
